/* eslint-disable camelcase */
import React, { useContext, useMemo } from 'react';
import { Link, useMatch, useNavigate } from 'react-router-dom';
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import { useQuery, ApolloError } from '@apollo/client';
import Loader from '../../../components/Loader';
import moment from 'moment';
import useResponsive from '../../../hooks/useResponsive';
import { useAddProductToCart } from '../../../hooks/useAddProductToCart';
import ScreenLoader from '../../ScreenLoader/ScreenLoader';
import { usePopup } from '../../../context/PopupContext';
import Prices from '../../BaseCurrencyPrices/Prices';
import { GET_ORDERBOOK } from './orderbookQuery';
import formatLocalePrice from '../../../utils/formatLocalePrice';
import './PersonalAreaOrders.scss';

const PersonalAreaOrders = () => {
  const navigate = useNavigate(); // Zmiana z history na navigate
  const { loading, error, data } = useQuery(GET_ORDERBOOK, {
    fetchPolicy: 'no-cache',
  });

  const reversedItems = useMemo(() => {
    return data && data.customerOrderbook.orders.items.reverse();
  }, [data]);

  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const match = useMatch('/customer/account/orders/*'); // Zmiana z useRouteMatch na useMatch
  const path = match?.path || ''; // Ustawienie domyślnej wartości w przypadku undefined

  const { addProductsToCart, addProductResult } = useAddProductToCart();
  const { showAddToCartPopupMessage } = usePopup();

  if (error) {
    console.log('Error: ', error.message);
  }

  const addProductsToCartHandler = async items => {
    try {
      await addProductsToCart(
          items.map(item => ({
            sku: item.product_sku,
            quantity: item.quantity_ordered,
          })),
      );

      navigate('/checkout/cart'); // Zmiana z history.push na navigate
    } catch (ex) {
      if (ex instanceof ApolloError) {
        if (ex.message.includes('requested qty')) {
          const sku = ex.message.match(/SKU (\d+)/)[1];
          const item = items.find(({ product_sku }) => product_sku === sku);
          const message = t('messagePopup.orderQtyError').replace('[product]', item.product_name);
          showAddToCartPopupMessage(message, 'error', 3000);
          return;
        }
      }

      console.error(ex);
    }
  };

  return (
      <div className="orders">
        {addProductResult.loading && <ScreenLoader />}

        <span className="personal-area-title">
        <T id="orders.myOrders" />
      </span>

        {!loading && data && data.customerOrderbook.orders.items.length === 0 && (
            <p className="orders__no-orders">
              <T id="orders.noOrders" />
            </p>
        )}

        {(loading || !data) && <Loader />}

        {data && !loading && data.customerOrderbook.orders.items.length > 0 && (
            <div className="orders__content">
              <table className="orders__content__table">
                {!isMobile && (
                    <thead>
                    <tr>
                      <th className="col">
                        <T id="personalArea.oneOrder" /> #
                      </th>
                      <th className="col">
                        <T id="club.date" />
                      </th>
                      <th className="col">
                        <T id="personalArea.deliveryOn" />
                      </th>
                      <th className="col">
                        <T id="cartSummary.totalFinal" />
                      </th>
                      <th className="col">
                        <T id="orders.orderStatus" />
                      </th>
                      <th className="col" />
                    </tr>
                    </thead>
                )}

                <tbody>
                {reversedItems.map(({ id, order_date, shipping_address, status, total, items }) => {
                  const order_id = atob(id);
                  const date = moment(order_date).format('l');
                  const { firstname, lastname } = shipping_address;
                  const { value } = total.grand_total;

                  return (
                      <tr key={id}>
                        <td>
                          {isMobile && (
                              <span className="orders__content__table-status">
                          <T id="personalArea.oneOrder" />:
                        </span>
                          )}
                          {order_id}
                        </td>
                        <td>
                          {isMobile && (
                              <span className="orders__content__table-status">
                          <T id="club.date" />:
                        </span>
                          )}
                          {date}
                        </td>
                        <td>
                          {isMobile && (
                              <span className="orders__content__table-status">
                          <T id="personalArea.deliveryOn" />:
                        </span>
                          )}
                          {firstname} {lastname}
                        </td>
                        <td>
                          {isMobile && (
                              <span className="orders__content__table-status">
                          <T id="cartSummary.totalFinal" />:
                        </span>
                          )}
                          <span className="orders__content__table-price">
                        <Prices amount={value} breakRow isMinicart />
                      </span>
                        </td>
                        <td className="orders__content__table-status">
                          {isMobile && (
                              <span className="orders__content__table-status">
                          <T id="orders.orderStatus" />:
                        </span>
                          )}
                          {status}
                        </td>
                        <td>
                          <Link to={`${path}/${id}`}>
                            <button className="btn btn_profile" type="button">
                              <T id="orders.checkOrder" />
                            </button>
                          </Link>
                          <button className="btn btn_profile" onClick={() => addProductsToCartHandler(items)} type="button">
                            <T id="orders.repeatOrder" />
                          </button>
                        </td>
                      </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
        )}

        {!loading && (
            <Link className="orders__link" to="/customer/account/">
              <T id="orders.back" />
            </Link>
        )}
      </div>
  );
};

export default PersonalAreaOrders;